module.exports = __webpack_public_path__ + "img/truck-01.40165be6.svg";